(function() {
    'use strict';

    var cfg = { freeShipQty: 2, standardShip: 8000, variants: [] };
    var cfgEl = document.getElementById('cd-config');
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {} }
    var root = (cfg.root || '/').replace(/\/?$/, '/');
    var mutating = false, lastCart = null, drawerTrigger = null;
    var rules = window.CottonSalwarCartRules;

    // paise — mirrors the "Buy 2+ — ₹450 each" automatic discount (₹40 off per piece on 2+)
    var PER_ITEM_DISC = 4000;

    var COLORS = {
        Black: '#1a1a1a', White: '#FAFAFA', Red: '#CC2936', Maroon: '#8B1538',
        Pink: '#E75480', Yellow: '#F4C430', Green: '#2E7D32', Blue: '#1565C0',
        Navy: '#1A237E', Orange: '#E65100', Purple: '#6A1B9A', Grey: '#757575',
        Peach: '#FFAB91', Rust: '#A0522D', Chiko: '#D2B48C',
        'Kesar Ochre': '#C8912A', 'Neem Sage': '#A9C48B', 'Bottle Green': '#1F4A38', 'Peacock Teal': '#1E4D6B', 'Cocoa Brown': '#6B3F2E',
        'Turquoise Blue': '#1E8C86', 'Deep Plum': '#4B2140', 'Dusty Rose': '#C9718A', 'Surkhi Clay': '#B5492F', 'Mint Green': '#4FBF7A'
    };

    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cdOverlay');
    if (!drawer || !overlay) return;

    var elItems = document.getElementById('cdItems');
    var elEmpty = document.getElementById('cdEmpty');
    var elNudge = document.getElementById('cdNudge');
    var elFoot = document.getElementById('cdFoot');
    var elSummary = document.getElementById('cdSummary');
    var elCount = document.getElementById('cdCount');
    var elPick = document.getElementById('cdPick');
    var elPickGrid = document.getElementById('cdPickGrid');
    var elPickAdd = document.getElementById('cdPickAdd');
    var elTitle = drawer.querySelector('.cd-title');

    function money(paise) {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: lastCart && lastCart.currency || 'INR', maximumFractionDigits: 2 }).format(paise / 100);
    }

    var elScroll = drawer.querySelector('.cd-scroll');
    // Pin the value module (last child of the scroll area) into view so it is
    // never guillotined mid-card on short mobile viewports; items clip on top
    // instead, which reads as a natural scroll cue.
    function showModule() {
        if (elScroll) elScroll.scrollTop = elScroll.scrollHeight;
    }

    function open() {
        drawerTrigger = document.activeElement;
        drawer.inert = false;
        drawer.classList.add('open');
        overlay.classList.add('show');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        showModule();
        document.getElementById('cdClose').focus();
    }
    function close() {
        if (!drawer.classList.contains('open')) return;
        drawer.classList.remove('open');
        overlay.classList.remove('show');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.inert = true;
        document.body.style.overflow = '';
        if (drawer.classList.contains('picking')) { exitPicker(); refresh(); }
        if (drawerTrigger) drawerTrigger.focus();
    }

    // --- Colour picker (catalogue) mode ---
    var picked = {};
    var UNIT = 49000; // fallback; real price comes from cd-config variants

    function pickLabel() {
        var n = Object.keys(picked).length;
        var unit = (cfg.variants && cfg.variants[0] && cfg.variants[0].price) || UNIT;
        if (n === 0) return { n: 0, label: 'Pick a colour' };
        if (n === 1) return { n: 1, label: 'Add colour to bag' };
        var total = n * (unit - PER_ITEM_DISC);
        return { n: n, label: 'Add ' + n + ' to bag — ' + money(total) };
    }

    function renderPick() {
        elPickGrid.innerHTML = (cfg.variants || []).map(function(v) {
            var img = v.img
                ? '<img src="' + v.img + '" alt="' + v.name + '" loading="lazy">'
                : '<span class="cd-pick-fill" style="background:' + (COLORS[v.name] || '#CCC') + '"></span>';
            if (!v.available) {
                return '<div class="cd-pick-card oos" aria-disabled="true">' +
                    img + '<span class="cd-oos-badge">Out of stock</span><span class="nm">' + v.name + '</span></div>';
            }
            var sel = picked[v.id] ? ' sel' : '';
            return '<div class="cd-pick-card' + sel + '" data-act="pick" data-id="' + v.id + '" role="button" tabindex="0" aria-label="' + v.name + '" aria-pressed="' + (sel ? 'true' : 'false') + '">' +
                img + '<span class="tick">&#10003;</span><span class="nm">' + v.name + '</span></div>';
        }).join('');
        var s = pickLabel();
        elPickAdd.textContent = s.label;
        elPickAdd.disabled = s.n === 0;
        var hint = document.getElementById('cdPickHint');
        if (hint) hint.hidden = s.n !== 1;
    }

    function openPicker(preselectId) {
        picked = {};
        // Hero dots can carry a variant that has since sold out — never preselect one
        if (preselectId) {
            var ok = (cfg.variants || []).some(function(v) { return String(v.id) === String(preselectId) && v.available; });
            if (ok) picked[preselectId] = true;
        }
        drawer.classList.add('picking');
        elPick.hidden = false;
        elItems.hidden = true;
        elNudge.hidden = true;
        elEmpty.hidden = true;
        elFoot.style.display = 'block';
        if (elTitle && elTitle.childNodes[0]) elTitle.childNodes[0].textContent = 'Pick Your Colours ';
        renderPick();
        open();
        if (elScroll) elScroll.scrollTop = 0;
    }

    function exitPicker() {
        picked = {};
        drawer.classList.remove('picking');
        elPick.hidden = true;
        if (elTitle && elTitle.childNodes[0]) elTitle.childNodes[0].textContent = 'Your Bag ';
    }

    function syncSticky(cart, grandTotal) {
        var sticky = document.getElementById('stickyCart');
        if (!sticky) return;
        var nameEl = sticky.querySelector('.name');
        var priceEl = sticky.querySelector('.price');
        var btn = document.getElementById('stickyCartBtn');
        if (cart.item_count > 0) {
            if (nameEl) nameEl.textContent = 'Your Bag (' + cart.item_count + ')';
            if (priceEl) priceEl.textContent = rules && rules.count(cart) === 1 ? 'Choose 1 more salwar' : money(grandTotal);
            if (btn) btn.textContent = 'View Bag';
            sticky.dataset.mode = 'bag';
        } else {
            sticky.dataset.mode = 'add';
        }
    }

    function render(cart) {
        lastCart = cart;
        elCount.textContent = '(' + cart.item_count + ')';

        // While the colour picker is up, don't let an in-flight cart render
        // (e.g. the initial page-load refresh) swap the picker UI for the
        // bag/empty modules — exitPicker() re-renders when picking ends.
        var picking = drawer.classList.contains('picking');

        if (cart.item_count === 0) {
            elItems.innerHTML = '';
            elItems.hidden = true;
            elNudge.hidden = true;
            if (!picking) {
                elFoot.style.display = 'none';
                elEmpty.hidden = false;
            }
            syncSticky(cart, 0);
            return;
        }

        elEmpty.hidden = true;
        if (!picking) {
            elItems.hidden = false;
        }
        elFoot.style.display = 'block';

        // Line items
        elItems.innerHTML = cart.items.map(function(it) {
            var img = it.image ? '<img class="cd-item-img" src="' + it.image + '" alt="' + (it.product_title || '') + '">'
                               : '<div class="cd-item-img"></div>';
            return '<div class="cd-item">' +
                img +
                '<div class="cd-item-info">' +
                    '<div class="cd-item-name">' + it.product_title + '</div>' +
                    '<div class="cd-item-variant">' + (it.variant_title || 'Free Size') + '</div>' +
                    '<div class="cd-qty">' +
                        '<button data-act="dec" data-key="' + it.key + '">−</button>' +
                        '<span>' + it.quantity + '</span>' +
                        '<button data-act="inc" data-key="' + it.key + '">+</button>' +
                    '</div>' +
                '</div>' +
                '<div class="cd-item-right">' +
                    '<span class="cd-item-price">' + money(it.final_line_price) + '</span>' +
                    '<button class="cd-remove" data-act="rm" data-key="' + it.key + '">Remove</button>' +
                '</div>' +
            '</div>';
        }).join('');

        // Predicted shipping (our rule); discount comes straight from Shopify cart
        var qty = cart.item_count;
        var salwars = rules ? rules.count(cart) : 0;
        var onlySalwars = salwars === qty;
        var freeShip = cart.total_price >= 60000;
        var shipping = freeShip ? 0 : cfg.standardShip;
        var itemsNet = cart.total_price;
        var grandTotal = itemsNet + shipping;
        var saved = cart.total_discount + (freeShip ? cfg.standardShip : 0);

        // Nudge: pack comparison + always-on colour strip (tap = add, tap again = remove)
        var inCart = {};
        cart.items.forEach(function(it) { inCart[it.variant_title] = { key: it.key, quantity: it.quantity }; });
        var strip = (cfg.variants || []).map(function(v) {
            var hex = COLORS[v.name] || '#CCC';
            var line = inCart[v.name];
            if (line) {
                return '<span class="cd-nudge-sw sel" role="button" tabindex="0" aria-label="Remove one ' + v.name + '" style="background:' + hex + '" data-act="decvar" data-key="' + line.key + '" data-qty="' + line.quantity + '" title="' + v.name + ' — tap to remove">' +
                    (line.quantity > 1 ? '<i class="cd-sw-badge">' + line.quantity + '</i>' : '<i class="cd-sw-badge">&#10003;</i>') + '</span>';
            }
            if (!v.available) {
                return '<span class="cd-nudge-sw oos" style="background:' + hex + '" title="' + v.name + ' — out of stock"></span>';
            }
            return '<span class="cd-nudge-sw" role="button" tabindex="0" aria-label="Add ' + v.name + '" style="background:' + hex + '" data-act="addvar" data-id="' + v.id + '" title="' + v.name + '"></span>';
        }).join('');

        if (!freeShip) {
            var stripAdd = (cfg.variants || []).filter(function(v) {
                return !inCart[v.name];
            }).map(function(v) {
                var hex = COLORS[v.name] || '#CCC';
                if (!v.available) {
                    return '<span class="cd-nudge-sw oos" style="background:' + hex + '" title="' + v.name + ' — out of stock"></span>';
                }
                return '<span class="cd-nudge-sw" role="button" tabindex="0" aria-label="Add ' + v.name + '" style="background:' + hex + '" data-act="addvar" data-id="' + v.id + '" title="' + v.name + '"></span>';
            }).join('');
            var unit = cart.items[0].price;
            var perPiece = unit - PER_ITEM_DISC;
            var twoTotal = (unit - PER_ITEM_DISC) * 2;
            elNudge.className = 'cd-nudge cd-upgrade';
            elNudge.innerHTML =
                '<div class="cd-eq">2+ pieces = <strong>' + money(perPiece) + ' each</strong></div>' +
                '<div class="cd-eq-sub">any colours &middot; delivered free</div>' +
                '<div class="cd-boxes">' +
                    '<div class="cd-box hot">' +
                        '<span class="cd-box-badge">Better value</span>' +
                        '<span class="cd-box-name">2 pieces</span>' +
                        '<span class="cd-box-price">' + money(twoTotal) + '</span>' +
                        '<span class="cd-box-note">delivered &middot; <strong>' + money(perPiece) + ' each</strong></span>' +
                    '</div>' +
                '</div>' +
                '<div class="cd-up-pick">Pick one more colour</div>' +
                '<div class="cd-nudge-swatches cd-up-strip cd-one-line">' + stripAdd + '</div>';
            elNudge.hidden = picking;
        } else {
            elNudge.className = 'cd-nudge cd-upgrade';
            elNudge.innerHTML =
                '<div class="cd-eq"><span class="cd-eq-tick">&#10003;</span> <strong>' + money(Math.round(grandTotal / qty)) + ' each</strong> &middot; delivered free</div>' +
                '<div class="cd-up-cap">tap to add or remove colours</div>' +
                '<div class="cd-nudge-swatches cd-up-strip cd-one-line">' + strip + '</div>';
            elNudge.hidden = picking;
        }

        if (!onlySalwars || cart.currency && cart.currency !== 'INR') elNudge.hidden = true;

        // Summary
        var rows = '<div class="cd-sum-row"><span>Subtotal</span><span class="cd-sum-val">' + money(cart.original_total_price) + '</span></div>';
        if (cart.total_discount > 0) {
            rows += '<div class="cd-sum-row discount"><span>Discount</span><span class="cd-sum-val">−' + money(cart.total_discount) + '</span></div>';
        }
        if (onlySalwars && salwars >= 2 && (!cart.currency || cart.currency === 'INR')) {
            rows += '<div class="cd-sum-row"><span>Standard delivery</span><span class="cd-sum-val ' + (freeShip ? 'cd-sum-free' : '') + '">' + (freeShip ? 'FREE' : money(shipping)) + '</span></div>';
            rows += '<div class="cd-sum-row total"><span>Online total</span><span class="cd-sum-val">' + money(grandTotal) + '</span></div>';
        } else rows += '<div class="cd-sum-row total"><span>Item subtotal</span><span class="cd-sum-val">' + money(itemsNet) + '</span></div>';
        elSummary.innerHTML = rows;

        // Checkout button shows the total
        var checkoutBtn = document.getElementById('cdCheckout');
        if (checkoutBtn) {
            checkoutBtn.textContent = salwars === 1 ? 'Choose another colour' : 'Continue to checkout';
            checkoutBtn.disabled = mutating;
        }

        syncSticky(cart, grandTotal);
    }

    function fetchCart() {
        return fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
            .then(function(r) { if (!r.ok) throw new Error('Bag unavailable'); return r.json(); });
    }

    function refresh() {
        return fetchCart().then(function(cart) { render(cart); return cart; });
    }

    function changeQty(key, quantity) {
        if (mutating) return Promise.resolve();
        mutating = true;
        document.getElementById('cdCheckout').disabled = true;
        return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
        }).then(function(r) { if (!r.ok) throw new Error('Bag unavailable'); return r.json(); })
            .then(function(cart) { render(cart); return cart; })
            .catch(function() { drawer.querySelector('.cd-note').textContent = 'Could not update your bag. Checking the current items…'; return refresh(); })
            .catch(function() { window.location.href = root + 'cart'; })
            .finally(function() { mutating = false; if (lastCart) render(lastCart); });
    }

    function addVariant(variantId) {
        if (mutating) return Promise.resolve();
        mutating = true;
        document.getElementById('cdCheckout').disabled = true;
        return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        }).then(function(r) { if (!r.ok) throw new Error('Bag unavailable'); return refresh(); })
            .catch(function() { drawer.querySelector('.cd-note').textContent = 'Please review your items. A colour may be unavailable.'; return refresh(); })
            .catch(function() { window.location.href = root + 'cart'; })
            .finally(function() { mutating = false; if (lastCart) render(lastCart); });
    }

    // --- Event delegation inside drawer ---
    drawer.addEventListener('click', function(e) {
        if (mutating) return;
        var t = e.target.closest('[data-act]');
        if (!t) return;
        var act = t.dataset.act;
        var key = t.dataset.key;

        if (act === 'pick') {
            var vid = t.dataset.id;
            if (picked[vid]) { delete picked[vid]; } else { picked[vid] = true; }
            renderPick();
        } else if (act === 'inc') {
            var span = t.parentNode.querySelector('span');
            changeQty(key, parseInt(span.textContent) + 1);
        } else if (act === 'dec') {
            var span2 = t.parentNode.querySelector('span');
            changeQty(key, Math.max(0, parseInt(span2.textContent) - 1));
        } else if (act === 'rm') {
            changeQty(key, 0);
        } else if (act === 'addvar') {
            addVariant(t.dataset.id).then(showModule);
        } else if (act === 'decvar') {
            changeQty(key, Math.max(0, parseInt(t.dataset.qty) - 1)).then(showModule);
        }
    });

    document.getElementById('cdClose').addEventListener('click', close);
    document.getElementById('cdContinue').addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
    drawer.addEventListener('keydown', function(e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[role="button"][data-act]')) {
            e.preventDefault(); e.target.click(); return;
        }
        if (e.key !== 'Tab') return;
        var targets = Array.from(drawer.querySelectorAll('button:not([disabled]),a[href],[tabindex="0"]')).filter(function(node) { return node.getClientRects().length; });
        var first = targets[0], last = targets[targets.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.getElementById('cdCheckout').addEventListener('click', function() {
        if (mutating) return;
        var button = this; button.disabled = true;
        if (!rules) { window.location.href = root + 'cart'; return; }
        rules.checkout(function(message) { drawer.querySelector('.cd-note').textContent = message; })
            .finally(function() { button.disabled = false; });
    });
    document.getElementById('cdShop').addEventListener('click', function() {
        openPicker(null);
    });

    // Picker: add all selected colours in one call, then morph into the normal bag
    elPickAdd.addEventListener('click', function() {
        var ids = Object.keys(picked);
        if (!ids.length || mutating) return;
        mutating = true;
        elPickAdd.disabled = true;
        elPickAdd.textContent = 'Adding…';
        fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids.map(function(id) { return { id: parseInt(id), quantity: 1 }; }) })
        }).then(function(r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
        }).then(function() {
            exitPicker();
            return refresh();
        }).then(function() {
            showModule();
        }).catch(function() {
            exitPicker();
            drawer.querySelector('.cd-note').textContent = 'Please review your bag before adding again.';
            return refresh().catch(function() { window.location.href = root + 'cart'; });
        }).finally(function() { mutating = false; if (lastCart) render(lastCart); });
    });

    // Global triggers: hero CTA + hero colour dots (data-variant preselects that colour)
    document.addEventListener('click', function(e) {
        var t = e.target.closest('[data-open-picker]');
        if (!t) return;
        e.preventDefault();
        openPicker(t.getAttribute('data-variant') || null);
    });

    // Sticky bar: open drawer when it has items
    var stickyBtn = document.getElementById('stickyCartBtn');
    if (stickyBtn) {
        stickyBtn.addEventListener('click', function(e) {
            var sticky = document.getElementById('stickyCart');
            if (sticky && sticky.dataset.mode === 'bag') {
                e.preventDefault();
                open();
            } else {
                var p = document.getElementById('product');
                if (p) p.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    // Public API
    window.CottonCart = {
        open: open,
        close: close,
        refresh: refresh,
        openPicker: openPicker,
        openAfterAdd: function() {
            // The add already succeeded — open the drawer even if the cart refresh
            // hiccups (retry once first, e.g. flaky mobile networks)
            return refresh()
                .catch(function() { return refresh(); })
                .then(open, open);
        }
    };

    // Initial state (so sticky bar + count are correct on load)
    refresh().catch(function() { drawer.querySelector('.cd-note').textContent = 'Could not load your bag. Please refresh the page.'; });
})();
